/* eslint-disable @stylistic/max-len */
import { AxiosPromise } from 'axios';

import {
  BillsBillChargeCreatePayload,
  BillsBillChargeResponse,
  BillsBillChargeUpdatePayload,
  BillsBillChargeUpdateResponse,
} from './types';
import { baseClientConstructorProps } from '../config';
import { BaseClient, BaseClientConstructorProps, SendRequestPayload } from '../generated/baseClient';

class SettlementChargesClient extends BaseClient {
  private _namespace: string;

  constructor(props: BaseClientConstructorProps) {
    super(props);

    this._namespace = '/api/v1/settlement/charges';
  }

  readonly createCharge = (payload: BillsBillChargeCreatePayload): AxiosPromise<BillsBillChargeResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      data: payload,
      endpoint: this._namespace,
      method: 'POST',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly deleteCharge = (id: string): AxiosPromise<''> => {
    const sendRequestPayload: SendRequestPayload = {
      endpoint: `${this._namespace}/${id}`,
      method: 'DELETE',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };

  readonly updateCharge = (id: string, payload: BillsBillChargeUpdatePayload): AxiosPromise<BillsBillChargeUpdateResponse> => {
    const sendRequestPayload: SendRequestPayload = {
      data: payload,
      endpoint: `${this._namespace}/${id}`,
      method: 'PUT',
    };

    // eslint-disable-next-line @typescript-eslint/no-unsafe-return
    return this._sendRequest(sendRequestPayload);
  };
}

export const settlementChargesClient = new SettlementChargesClient(baseClientConstructorProps);
